import co from 'co'
import agent from 'superagent'
import misc from 'utils/misc'

// [A]sync API Collections
// all function will return a thunk or promise for co/generator support.

const aUtils = {
  post (path, data) {
    const req = agent
              .post(path)
              .send(data)
              .withCredentials()
    return req
  },

  postJSON (path, data) {
    return co(function *() {
      const req = agent
                .post(path)
                .send(data)
                .withCredentials()
      const res = yield req
      return JSON.parse(res.text).data
    })
  },

  getJSON (path) {
    return co(function *() {
      const req = agent
                  .get(path)
                  .withCredentials()
      const res = yield req
      return JSON.parse(res.text).data
    })
  },

  update (path, data) {
    const req = agent
              .put(`${path}/${data._id}`)
              .send(data)
              .withCredentials()
    return req
  },

  del (path, data) {
    const req = agent
              .del(`${path}/${data._id}`)
              .withCredentials()
    return req
  },

  logout () {
    return co(function *() {
      const res = yield agent
                        .post(`/api/auth/logout`)
                        .withCredentials()
      console.log(res)
    })
  },

  login (username, password) {
    return co(function *() {
      // yield _this.logout();
      const res = yield agent
                      .post(`/api/auth/login`)
                      .send({ account: username, password })
                      .withCredentials()
      console.log(res)
    })
  },

  me () {
    return this.getJSON('/api/me')
  },

  now () {
    return this.getJSON('/api/now')
  },
}

const aProjects = {
  find () {
    return aUtils.getJSON('/api/projects')
  },

  create (project) {
    return aUtils.postJSON('/api/projects', project)
  },

  update (project) {
    return aUtils.update('/api/projects', project)
  },
}

const aTasks = {
  find () {
    return aUtils.getJSON('/api/tasks')
  },

  create (task) {
    const processedTask = task
    processedTask.isEnabled = task.isEnabled === 'true' || task.isEnabled === true
    return aUtils.postJSON('/api/tasks', task)
  },

  update (task) {
    const processedTask = task
    processedTask.isEnabled = task.isEnabled === 'true' || task.isEnabled === true
    return aUtils.update('/api/tasks', processedTask)
  },
}

const aDates = {
  find () {
    return co(function *() {
      const dates = yield aUtils.getJSON('/api/dates')
      return dates.map(date => {
        const newDate = date
        newDate.date = misc.getValidDateString(date.date)
        return newDate
      })
    })
  },

  create (date) {
    const processedDate = date
    // processedDate.isWorking = date.isWorking === 'true' || date.isWorking === true
    processedDate.isWorking = date.isWorking
    processedDate.name = date.name
    processedDate.date = misc.getISODateString(date.date)
    // return aUtils.postJSON('/api/dates', date)
    return aUtils.postJSON('/api/dates', processedDate)
  },

  update (date) {
    const processedDate = {}
    processedDate._id = date._id
    // processedDate.isWorking = date.isWorking === 'true' || date.isWorking === true
    processedDate.isWorking = date.isWorking
    processedDate.name = date.name
    processedDate.date = misc.getISODateString(date.date)
    return aUtils.update('/api/dates', processedDate)
  },
}

const aUsers = {
  userToEmpty (user) {
    if (user.role === 'user') {
      const newUser = misc.deepCopy(user)
      newUser.role = ''
      return newUser
    }
    return user
  },

  emptyToUser (user) {
    if (user.role === '' || !user.role) {
      const newUser = misc.deepCopy(user)
      newUser.role = 'user'
      return newUser
    }
    return user
  },

  find () {
    return co(function *() {
      const users = yield aUtils.getJSON('/api/users')
      return users.map(aUsers.emptyToUser)
    })
  },

  create (user) {
    const newUser = aUsers.userToEmpty(user)
    return aUtils.postJSON('/api/users', newUser)
  },

  update (user) {
    const newUser = aUsers.userToEmpty(user)
    return aUtils.update('/api/users', newUser)
  },
}

const aWeekReports = {
  find (uid, monday) {
    if (uid !== '') {
      return aUtils.getJSON(`/api/weekReports?userId=${uid}` +
                            `&monday=${monday.year}-${monday.month}-${monday.date}`)
    }
    return aUtils.getJSON('/api/weekReports?' +
                          `monday=${monday.year}-${monday.month}-${monday.date}`)
  },

  create (weekReport) {
    return aUtils.postJSON('/api/weekReports', weekReport)
  },

  update (weekReport) {
    return aUtils.update('/api/weekReports', weekReport)
  },

  del (weekReport) {
    return aUtils.del('/api/weekReports', weekReport)
  },
}

const aRecords = {
  find (uid, start, end) {
    return aUtils.getJSON(`/api/records?userId=${uid}` +
                          `&start=${start.year}-${start.month}-${start.date}` +
                          `&end=${end.year}-${end.month}-${end.date}`)
  },

  findRange (start, end) {
    return aUtils.getJSON(`/api/records?` +
                          `start=${start.year}-${start.month}-${start.date}` +
                          `&end=${end.year}-${end.month}-${end.date}`)
  },

  findWeek (uid, weekStart) {
    const start = weekStart
    const end = misc.getSunday(weekStart)
    return aUtils.getJSON(`/api/records?userId=${uid}` +
                          `&start=${start.year}-${start.month}-${start.date}` +
                          `&end=${end.year}-${end.month}-${end.date}`)
  },

  create (record) {
    return aUtils.postJSON('/api/records', record)
  },

  update (record) {
    return aUtils.update('/api/records', record)
  },

  del (record) {
    return aUtils.del('/api/records', record)
  },
}

export { aUtils, aProjects, aTasks, aUsers, aRecords, aWeekReports, aDates }



// WEBPACK FOOTER //
// ./src/app/utils/aUtils.js